import * as React from 'react';
import { PickupRead } from '../../../../transportation/models/pickups/_index';
import { EditPickupDocuments } from './EditPickupDocuments';
import { EditPickupStatus } from './EditPickupStatus';

interface IProps {
    pickup: PickupRead;
    updatePickupState: any;
    downloadPaperwork: any;
}

export const EditPickupSidebar = (props: IProps) => {
    return <div className="col-3 shipment-sidebar">

            {/* Status Control */}
            <EditPickupStatus 
                pickup={ props.pickup } 
                updatePickupState={ props.updatePickupState }
            />

            {/* Documents Control */}
            {
                props.pickup.id > 0
                    ? <EditPickupDocuments
                        pickupId={ props.pickup.id}
                        onDownloadPaperwork={ props.downloadPaperwork }
                    />
                    : null
            }
            
        </div>;        
};
